import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Ico_Beta",
  "use": "Ico_Beta-usage",
  "viewBox": "0 0 50 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 24\" id=\"Ico_Beta\">\n    <rect width=\"50\" height=\"24\" rx=\"12\" style=\"opacity:.3\" />\n    <text transform=\"translate(10 5)\" style=\"font-size:16px;font-family:MyriadPro-Regular,Myriad Pro\"><tspan x=\"0\" y=\"12\">Beta</tspan></text>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol